import { AssetLogo, WithNAFallback } from '@toggle/design-system';
import { formatTicker, MappedEntity } from '@toggle/toggle';
import React from 'react';

import { useEarningsInsightsFilter } from '~/hooks/use-earnings-insights-filter/useEarningsInsightsFilter';
import { parseEarningsInsights } from '~/hooks/use-earnings-insights-filter/utils';
import { useFlags } from '~/stores/use-flags/useFlags';
import { EarningsInsightIcon } from '~/views/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-icon/EarningsInsightIcon';

import * as S from './CompanyCell.styles';

export interface CompanyCellProps {
  entity: MappedEntity;
  earningsId: string;
}

export const CompanyCell = ({ entity, earningsId }: CompanyCellProps) => {
  const isEarningsInsightsEnabled = useFlags(state =>
    state.getFeatureFlagState('earnings_insights')
  );

  const { data: earningsInsightsData = [] } = useEarningsInsightsFilter({
    body: { earnings_ids: [earningsId] },
    isEnabled: isEarningsInsightsEnabled,
  });
  const earningsInsight = parseEarningsInsights(earningsInsightsData);

  return (
    <WithNAFallback
      value={
        entity && (
          <S.TickerWrapper>
            <AssetLogo entity={entity} isDarkTheme size={20} />
            <S.Ticker>{formatTicker(entity)}</S.Ticker>
            {!!earningsInsight && isEarningsInsightsEnabled && (
              <EarningsInsightIcon
                entityTag={entity.tag}
                size={20}
                earningsInsight={earningsInsight}
              />
            )}
          </S.TickerWrapper>
        )
      }
    />
  );
};
